import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GeneralSearch } from '../api/general-search';
import { SearchItem } from '../api/search-item';

@Injectable()
export class AgentService {

  constructor(private httpClient: HttpClient) {
  }

  public getAgents(searchRequirements: GeneralSearch): Observable<SearchItem[]> {
    const url = '/patent/open/report/search/agent';

    return this.httpClient.post<SearchItem[]>(url, searchRequirements);
  }

  public getAgentByAreaCode(searchRequirements: GeneralSearch): Observable<SearchItem[]> {
    const url = '/patent/open/report/search/agent/area_code';

    return this.httpClient.post<SearchItem[]>(url, searchRequirements);
  }
}
